module.exports = __webpack_public_path__ + "assets/tutorials/Reviewing_Selections.png";